export default __webpack_public_path__ + "79ebe37e447faf4f3ceb311336e35e4d.png";